import React, { Component, Fragment } from 'react';

import store from '../store/store.js'

import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import RaisedButton from 'material-ui/RaisedButton';
import PickButton from './PickButton.jsx';

const AutoHotels = (props) => {
  var subheader = '';

  const hotels = store.getHotelsForTur(store.options.tur.id);

  const handleClick = (item) => {
    store.setHotel(item.hotel); 
    store.options.summa = item.link.cena;
    props.click();
  }

  const listrow = (row, index) => {
    var Sub = null;
    if (subheader !== row.hotel.hotelgroup) {
      subheader = row.hotel.hotelgroup; 
      Sub = ( <TableRow>
                <TableRowColumn style={{width: "40%"}}>
                  <h2>{subheader}</h2>
                  <p> город: <b>{row.hotel.city}</b> </p>
                </TableRowColumn>
                <TableRowColumn> </TableRowColumn>
                <TableRowColumn> </TableRowColumn>
                <TableRowColumn> </TableRowColumn>
                <TableRowColumn> </TableRowColumn>
              </TableRow> ) 
      } 
    var kol = row.link.kol;
    if ( row.link.kol === '0' ) { kol = 'Под запрос' };
    if ( parseInt(row.link.kol, 10) < 0 ) { kol = 'Мест нет' }

    return (  <Fragment key={row.hotel.id}>
                {Sub}
              <TableRow >
                <TableRowColumn style={{width: "40%"}}> {row.hotel.name} </TableRowColumn>
                <TableRowColumn> {row.link.cena} </TableRowColumn>
                <TableRowColumn> {kol} </TableRowColumn>
                <TableRowColumn> </TableRowColumn>
                <TableRowColumn>
                  <PickButton label="Выбрать" 
                    onClick={()=>{ handleClick(row) } }
                    type={row.link.kol}
                    />
                </TableRowColumn>
              
              </TableRow>
              </Fragment>);
  }
    
    return (
    <Fragment>
    <h2> {store.options.tur.name} </h2>
    
    <Table selectable={false}>
      <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
        <TableRow>
          <TableHeaderColumn style={{width: "40%"}}>Отель</TableHeaderColumn>
          <TableHeaderColumn>Цена</TableHeaderColumn>
          <TableHeaderColumn>Количество комнат</TableHeaderColumn>
          <TableHeaderColumn ></TableHeaderColumn>
          <TableHeaderColumn ></TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody 
        displayRowCheckbox={false}
        >
      {hotels.map(listrow)}

      </TableBody>
      
    </Table>
    </Fragment>
    )
}


export default AutoHotels;




// WEBPACK FOOTER //
// ./src/coms/AutoHotels.jsx